import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";
import { useAppSettings } from "@/hooks/useAppSettings";
import { GraduationCap } from "lucide-react";

export default function About() {
  const { brand } = useAppSettings();
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <header className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-gradient-primary flex items-center justify-center shadow-glow overflow-hidden">
            {brand.logoUrl ? <img src={brand.logoUrl} alt={brand.name} className="h-full w-full object-cover" /> : <GraduationCap className="h-5 w-5 text-primary-foreground" />}
          </div>
          <span className="font-bold">{brand.name || "Nihongo"}</span>
        </Link>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Button asChild><Link to="/auth">Get started</Link></Button>
        </div>
      </header>
      <main className="container mx-auto px-4 py-16 max-w-3xl space-y-6">
        <h1 className="text-4xl font-bold">About {brand.name || "Nihongo"}</h1>
        <p className="text-lg text-muted-foreground">
          We help learners go from zero to JLPT N1 with a modern, focused study experience.
        </p>
        <h2 className="text-2xl font-semibold mt-8">Our approach</h2>
        <p>
          Traditional textbooks are great, but they're not interactive. We combine structured lessons (so you know what to learn next),
          spaced-repetition flashcards (so you don't forget), and timed tests (so you measure progress) into one app.
        </p>
        <h2 className="text-2xl font-semibold mt-8">Built-in dictionary</h2>
        <p>
          Search any word powered by Jisho's open dictionary. Save favorites, see JLPT level, parts of speech, and example sentences.
        </p>
      </main>
    </div>
  );
}
